export default __webpack_public_path__ + "static/media/OTListOn.13dcd006.svg";